package com.neurobs.react.semanticui

import com.neurobs.react.{ElementModifiers, ReactUtil}
import slinky.core.facade.ReactElement
import slinky.web.html._

object UiCardFactory {

  private def TemplateCardGroup(children: ReactElement*)(uiElementModifiers: UiElementModifiers) = {
    div(
      className := uiElementModifiers.formattedClassName("cards"),
      style := uiElementModifiers.createStyle
    )(
      children:_*
    )
  }

  private def TemplateCard(children: ReactElement*)(uiElementModifiers: UiElementModifiers) = {
    div(
      className := uiElementModifiers.formattedClassName("card"),
      style := uiElementModifiers.createStyle
    )(
      children:_*
    )
  }

  private def TemplateCardContent(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    div(
      className := "content " + elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children:_*
    )
  }

  private def TemplateCardHeader(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    div(
      className := "header " + elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children:_*
    )
  }

  private def TemplateCardMeta(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    div(
      className := "meta " + elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children:_*
    )
  }

  private def TemplateCardDescription(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    div(
      className := "description " + elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children:_*
    )
  }

  private def TemplateCardExtraContent(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    div(
      className := "extra content " + elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children:_*
    )
  }

  def CardGroup(children: ReactElement*)(implicit uiElementModifiers: UiElementModifiers) = {
    TemplateCardGroup(children)(uiElementModifiers)
  }

  def Card(children: ReactElement*)(implicit uiElementModifiers: UiElementModifiers) = {
    TemplateCard(children)(uiElementModifiers)
  }

  def Content(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateCardContent(children)(elementModifiers)
  }

  def Header(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateCardHeader(children)(elementModifiers)
  }

  def TextHeader(text: String)(implicit elementModifiers: ElementModifiers) = {
    TemplateCardHeader(text)(elementModifiers)
  }

  def TextMeta(text: String)(implicit elementModifiers: ElementModifiers) = {
    TemplateCardMeta(text)(elementModifiers)
  }

  def Description(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateCardDescription(children)(elementModifiers)
  }

  def TextDescription(text: String)(implicit elementModifiers: ElementModifiers) = {
    TemplateCardDescription(text)(elementModifiers)
  }

  def ExtraContent(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateCardExtraContent(children)(elementModifiers)
  }

}
